import { connect } from 'react-redux'

import QuestionnaireError from './../QuestionnaireError'

function mapStateToProps(state) {
  return {
    error: state.wopiQuestionnaire.get('error')
  }
}

function mapDispatchToProps(dispatch) {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(QuestionnaireError)



// WEBPACK FOOTER //
// ./src/components/smart/QuestionnaireErrorContainer.js